import { TimeInput } from './TimeInput';
import { MinuteState } from '../_types';
import { useInputs } from '../useInputs';

export const MinuteInput = () => {
  const { state, setState, isView } = useInputs<MinuteState>();
  return (
    <TimeInput
      time={state.startAt}
      onTimeChange={(newTime) =>
        setState((state) => ({ ...state, startAt: newTime }))
      }
      InputProps={{ readOnly: isView }}
      label="Start at:"
    />
  );
};
